import { CheckEmailForm } from '../../../components/forms';

export const CheckEmail = () => {
  return (
    <div className="columns">
      <CheckEmailForm />
    </div>
  );
};
